import { render, staticRenderFns } from "./ProductDetail_Drawings.vue?vue&type=template&id=eed83a68&scoped=true"
import script from "./ProductDetail_Drawings.vue?vue&type=script&lang=js"
export * from "./ProductDetail_Drawings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed83a68",
  null
  
)

export default component.exports